// Content comparison for the business state, independent of object identity and key
// order. Firestore returns maps with its own key order and the client builds new
// objects on every merge, so neither `===` nor plain JSON.stringify can tell whether
// two states hold the same data.
(function () {
  const stableJson = (value) => JSON.stringify(value, (_key, item) => (
    item && typeof item === 'object' && !Array.isArray(item)
      ? Object.fromEntries(Object.keys(item).sort().map((key) => [key, item[key]]))
      : item
  ));

  // Top-level keys of `next` whose content differs from `previous`. A key missing
  // from `previous` counts as changed.
  const changedKeys = (next, previous) => {
    const base = previous && typeof previous === 'object' ? previous : {};
    return Object.keys(next || {}).filter((key) => stableJson(next[key]) !== stableJson(base[key]));
  };

  const sameContent = (a, b) => a === b || (!!a && !!b && stableJson(a) === stableJson(b));
  window.PlummeStateContent = { stableJson, changedKeys, sameContent };

  const waitForChange=async(fingerprint,previous,timeoutMs=2500)=>{const deadline=Date.now()+timeoutMs;while(Date.now()<deadline){if(fingerprint()!==previous)return true;await new Promise((resolve)=>window.setTimeout(resolve,50));}return false;};
  const runWithStateRevisionRetry=async({fingerprint,operation,isConflict,maxAttempts=3})=>{let lastError=null;for(let attempt=0;attempt<maxAttempts;attempt+=1){const previous=fingerprint();try{return await operation();}catch(error){lastError=error;if(!isConflict(error)||attempt===maxAttempts-1)throw error;await waitForChange(fingerprint,previous);}}throw lastError;};
  window.PlummeStateContent.runWithStateRevisionRetry = runWithStateRevisionRetry;
})();
